import { Component } from '@angular/core';

@Component({
  selector: 'ngx-cmspage',
  template: `<router-outlet></router-outlet>`,
})
export class CmsPageComponent {
}
